;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/claims/:qid\",\"regex\":\"^/claims/([^/]+)$\",\"paramNames\":[\"qid\"],\"hasOptionalPrefix\":false},{\"path\":\"/price-lists/:qid/edit-price-list\",\"regex\":\"^/price-lists/([^/]+)/edit-price-list$\",\"paramNames\":[\"qid\"],\"hasOptionalPrefix\":false},{\"path\":\"/price-lists/:qid/edit-price-list/volume-pricing\",\"regex\":\"^/price-lists/([^/]+)/edit-price-list/volume-pricing$\",\"paramNames\":[\"qid\"],\"hasOptionalPrefix\":false},{\"path\":\"/price-lists/:qid/upload-new-file\",\"regex\":\"^/price-lists/([^/]+)/upload-new-file$\",\"paramNames\":[\"qid\"],\"hasOptionalPrefix\":false},{\"path\":\"/price-lists/add-price-list/:qid\",\"regex\":\"^/price-lists/add-price-list/([^/]+)$\",\"paramNames\":[\"qid\"],\"hasOptionalPrefix\":false},{\"path\":\"/price-lists/add-price-list/:qid/volume-pricing\",\"regex\":\"^/price-lists/add-price-list/([^/]+)/volume-pricing$\",\"paramNames\":[\"qid\"],\"hasOptionalPrefix\":false},{\"path\":\"/special-offer-requests/:qid\",\"regex\":\"^/special-offer-requests/([^/]+)$\",\"paramNames\":[\"qid\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/app-router-migration/inventory\"},{\"path\":\"/app-router-migration/orders\"},{\"path\":\"/claims\"},{\"path\":\"/help-center\"},{\"path\":\"/insights\"},{\"path\":\"/integrations\"},{\"path\":\"/integrations/order-placement\"},{\"path\":\"/integrations/stock-ingestion\"},{\"path\":\"/my-profile\"},{\"path\":\"/my-profile/billing-address\"},{\"path\":\"/my-profile/chamber-of-commerce\"},{\"path\":\"/my-profile/payment-details\"},{\"path\":\"/my-profile/sell-to\"},{\"path\":\"/my-profile/shipping-address\"},{\"path\":\"/price-lists\"},{\"path\":\"/price-lists/add-price-list\"},{\"path\":\"/special-offer-requests\"},{\"path\":\"/\"},{\"path\":\"/legal/terms\"},{\"path\":\"/login\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.3.5";import { initFaro } from '@qogita/observability/init-faro'
import * as Sentry from '@sentry/nextjs'
import posthog from 'posthog-js'
import { NEXT_PUBLIC_OBSERVABILITY_ENABLED } from 'src/core/observability/config'
import {
  NEXT_PUBLIC_GRAFANA_FARO_URL,
  NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA,
  WEB_SELLERS_APP_NAME,
} from 'src/core/observability/constants.browser'
import {
  NEXT_PUBLIC_SENTRY_DSN,
  NEXT_PUBLIC_SENTRY_ENABLED,
  NEXT_PUBLIC_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE,
  NEXT_PUBLIC_SENTRY_REPLAYS_SESSION_SAMPLE_RATE,
} from 'src/core/sentry/constants.mjs'

import { posthogConfig } from './core/posthog/config'

if (NEXT_PUBLIC_OBSERVABILITY_ENABLED) {
  initFaro({
    url: NEXT_PUBLIC_GRAFANA_FARO_URL,
    appName: WEB_SELLERS_APP_NAME,
    appVersion: NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA,
  })
}

if (NEXT_PUBLIC_SENTRY_ENABLED) {
  Sentry.init({
    dsn: NEXT_PUBLIC_SENTRY_DSN,
    sendDefaultPii: false,
    integrations: [
      Sentry.replayIntegration(),
      Sentry.thirdPartyErrorFilterIntegration({
        filterKeys: ['qogita-web-sellers'],
        behaviour: 'drop-error-if-contains-third-party-frames',
      }),
    ],
    replaysSessionSampleRate: NEXT_PUBLIC_SENTRY_REPLAYS_SESSION_SAMPLE_RATE,
    replaysOnErrorSampleRate: NEXT_PUBLIC_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE,
  })
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart

if (posthogConfig.enabled) {
  posthog.init(posthogConfig.projectToken, {
    api_host: posthogConfig.host,
    capture_exceptions: false,
    autocapture: false,
    capture_pageview: 'history_change',
    capture_pageleave: false,
    disable_session_recording: true,
    opt_out_capturing_by_default: true,
  })
}
